<template>
  <div
    class="b-booking-aside__total-cost mb-20"
    :class="{
      'b-booking-aside__total-cost--miles mb-12': redeemMilesEnabled,
    }">
    <div>
      <span v-if="!redeemMilesEnabled" class="extrabold">
        {{ dictionary.asideCostTotal }}
      </span>
      <span v-else>{{ mbDictionary.milesNCashAsideTotalCostText }}</span>
      <br />
      <div v-if="!redeemMilesEnabled">
        <span v-if="payment?.IsPrepaid">
          {{ dictionary.asideCostTotalPrepaid }}
        </span>
        <span v-else>
          {{ dictionary.asideCostTotalPayOnReturn }}
        </span>
      </div>
    </div>
    <em v-html="payment?.TotalCost"></em>
  </div>

  <div
    v-if="redeemMilesEnabled && milesData"
    class="b-booking-aside__miles-cost">
    <div class="b-booking-aside__miles-paid-miles">
      <span>{{ mbDictionary.milesNCashAsideRedeemText }}</span>
      <div class="price d-flex">
        <em>
          - €{{
            milesData.discountAmount.toLocaleString(lang, formatOptions)
          }}&nbsp;
        </em>
      </div>
    </div>
  </div>

  <div
    v-if="redeemMilesEnabled && milesData"
    class="b-booking-aside__total-cost">
    <div>
      <span
        class="extrabold"
        v-html="mbDictionary.milesNCashAsideRemainingAmountText"></span>
    </div>
    <em>
      €{{ milesData.remainingAmount.toLocaleString(lang, formatOptions) }}
    </em>
  </div>
</template>

<script>
import * as lib from '../../../lib/lib'

export default {
  props: {
    payment: {
      required: true,
      type: Object,
    },
    redeemMilesEnabled: {
      required: false,
      type: Boolean,
    },
    milesData: {
      required: false,
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      mbDictionary: {},
      lang: 'en',

      formatOptions: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    }
  },
  mounted() {
    this.lang = lib.getLocaleFromLangAttr()

    if (lib.getData('milesNBonusData')) {
      const { dictionary, configuration } = lib.getData('milesNBonusData')
      this.mbDictionary = dictionary
      this.milesNBonusLoggedIn = configuration.milesNBonusLoggedIn
      this.rate = configuration.rate
      this.destinationAllowed = configuration.destinationAllowed
      this.nodeTypeAlias = configuration.nodeTypeAlias

      if (!this.destinationAllowed) {
        this.showMilesNBonus = false
      }
    }
  },
}
</script>
